import {
  getObject,
  getList,
} from "@surya-digital/leo-ts-types";
import { SingleSelectGraphTypeV1 } from "./singleSelectGraphTypeV1";
import { SingleSelectWithProportionGraphTypeV1 } from "./singleSelectWithProportionGraphTypeV1";
import { SingleSelectNpsGraphTypeV1 } from "./singleSelectNpsGraphTypeV1";
import { MultiSelectGraphTypeV1 } from "./multiSelectGraphTypeV1";
import { RankingGraphTypeV1 } from "./rankingGraphTypeV1";
import { OpenEndedGraphTypeV1 } from "./openEndedGraphTypeV1";
import { GroupChildGraphDetailsV1, GroupChildGraphDetailsV1DTO } from "./groupChildGraphDetailsV1";
import { GridElementGraphTypeV1, GridElementGraphTypeV1DTO, GridElementGraphTypeV1Enums } from "./gridElementGraphTypeV1";


export namespace QuestionViewGraphTypeV1 {
  export interface SingleSelectDTO {
    case: string;
    singleSelectGraphType: SingleSelectGraphTypeV1.SingleSelectGraphTypeV1DTO;
  }
  
  export class SingleSelect {
    readonly isQuestionViewGraphTypeV1SingleSelect: boolean = true;
  
    readonly singleSelectGraphType: SingleSelectGraphTypeV1.SingleSelectGraphTypeV1;
  
  
    constructor(
    singleSelectGraphType: SingleSelectGraphTypeV1.SingleSelectGraphTypeV1
    ) {
      this.singleSelectGraphType = singleSelectGraphType;
    }
  
    static fromDTO(dto: SingleSelectDTO): SingleSelect {
      const singleSelectGraphType = SingleSelectGraphTypeV1.fromDTO(getObject(dto, "singleSelectGraphType", InvalidQuestionViewGraphTypeV1SingleSelectSingleSelectGraphTypeError));
      return new SingleSelect(
        singleSelectGraphType
      );
    }
  
    toDTO(): SingleSelectDTO {
      const dto: SingleSelectDTO = {
        case: "SINGLE_SELECT",
          singleSelectGraphType: SingleSelectGraphTypeV1.toDTO(this.singleSelectGraphType)
      };
      return dto;
    }
    }
  
  SingleSelect.prototype.toString = function toString(): string {
    return `QuestionViewGraphTypeV1.SINGLE_SELECT(singleSelectGraphType='${this.singleSelectGraphType}')`;
  };
  
  export interface SingleSelectWithProportionDTO {
    case: string;
    singleSelectWithProportionGraphType: SingleSelectWithProportionGraphTypeV1.SingleSelectWithProportionGraphTypeV1DTO;
  }
  
  export class SingleSelectWithProportion {
    readonly isQuestionViewGraphTypeV1SingleSelectWithProportion: boolean = true;
  
    readonly singleSelectWithProportionGraphType: SingleSelectWithProportionGraphTypeV1.SingleSelectWithProportionGraphTypeV1;
  
  
    constructor(
    singleSelectWithProportionGraphType: SingleSelectWithProportionGraphTypeV1.SingleSelectWithProportionGraphTypeV1
    ) {
      this.singleSelectWithProportionGraphType = singleSelectWithProportionGraphType;
    }
  
    static fromDTO(dto: SingleSelectWithProportionDTO): SingleSelectWithProportion {
      const singleSelectWithProportionGraphType = SingleSelectWithProportionGraphTypeV1.fromDTO(getObject(dto, "singleSelectWithProportionGraphType", InvalidQuestionViewGraphTypeV1SingleSelectWithProportionSingleSelectWithProportionGraphTypeError));
      return new SingleSelectWithProportion(
        singleSelectWithProportionGraphType
      );
    }
  
    toDTO(): SingleSelectWithProportionDTO {
      const dto: SingleSelectWithProportionDTO = {
        case: "SINGLE_SELECT_WITH_PROPORTION",
          singleSelectWithProportionGraphType: SingleSelectWithProportionGraphTypeV1.toDTO(this.singleSelectWithProportionGraphType)
      };
      return dto;
    }
    }
  
  SingleSelectWithProportion.prototype.toString = function toString(): string {
    return `QuestionViewGraphTypeV1.SINGLE_SELECT_WITH_PROPORTION(singleSelectWithProportionGraphType='${this.singleSelectWithProportionGraphType}')`;
  };
  
  export interface SingleSelectNpsDTO {
    case: string;
    singleSelectNpsGraphType: SingleSelectNpsGraphTypeV1.SingleSelectNpsGraphTypeV1DTO;
  }
  
  export class SingleSelectNps {
    readonly isQuestionViewGraphTypeV1SingleSelectNps: boolean = true;
  
    readonly singleSelectNpsGraphType: SingleSelectNpsGraphTypeV1.SingleSelectNpsGraphTypeV1;
  
  
    constructor(
    singleSelectNpsGraphType: SingleSelectNpsGraphTypeV1.SingleSelectNpsGraphTypeV1
    ) {
      this.singleSelectNpsGraphType = singleSelectNpsGraphType;
    }
  
    static fromDTO(dto: SingleSelectNpsDTO): SingleSelectNps {
      const singleSelectNpsGraphType = SingleSelectNpsGraphTypeV1.fromDTO(getObject(dto, "singleSelectNpsGraphType", InvalidQuestionViewGraphTypeV1SingleSelectNpsSingleSelectNpsGraphTypeError));
      return new SingleSelectNps(
        singleSelectNpsGraphType
      );
    }
  
    toDTO(): SingleSelectNpsDTO {
      const dto: SingleSelectNpsDTO = {
        case: "SINGLE_SELECT_NPS",
          singleSelectNpsGraphType: SingleSelectNpsGraphTypeV1.toDTO(this.singleSelectNpsGraphType)
      };
      return dto;
    }
    }
  
  SingleSelectNps.prototype.toString = function toString(): string {
    return `QuestionViewGraphTypeV1.SINGLE_SELECT_NPS(singleSelectNpsGraphType='${this.singleSelectNpsGraphType}')`;
  };
  
  export interface MultiSelectDTO {
    case: string;
    multiSelectGraphType: MultiSelectGraphTypeV1.MultiSelectGraphTypeV1DTO;
  }
  
  export class MultiSelect {
    readonly isQuestionViewGraphTypeV1MultiSelect: boolean = true;
  
    readonly multiSelectGraphType: MultiSelectGraphTypeV1.MultiSelectGraphTypeV1;
  
  
    constructor(
    multiSelectGraphType: MultiSelectGraphTypeV1.MultiSelectGraphTypeV1
    ) {
      this.multiSelectGraphType = multiSelectGraphType;
    }
  
    static fromDTO(dto: MultiSelectDTO): MultiSelect {
      const multiSelectGraphType = MultiSelectGraphTypeV1.fromDTO(getObject(dto, "multiSelectGraphType", InvalidQuestionViewGraphTypeV1MultiSelectMultiSelectGraphTypeError));
      return new MultiSelect(
        multiSelectGraphType
      );
    }
  
    toDTO(): MultiSelectDTO {
      const dto: MultiSelectDTO = {
        case: "MULTI_SELECT",
          multiSelectGraphType: MultiSelectGraphTypeV1.toDTO(this.multiSelectGraphType)
      };
      return dto;
    }
    }
  
  MultiSelect.prototype.toString = function toString(): string {
    return `QuestionViewGraphTypeV1.MULTI_SELECT(multiSelectGraphType='${this.multiSelectGraphType}')`;
  };
  
  export interface RankingDTO {
    case: string;
    rankingGraphType: RankingGraphTypeV1.RankingGraphTypeV1DTO;
  }
  
  export class Ranking {
    readonly isQuestionViewGraphTypeV1Ranking: boolean = true;
  
    readonly rankingGraphType: RankingGraphTypeV1.RankingGraphTypeV1;
  
  
    constructor(
    rankingGraphType: RankingGraphTypeV1.RankingGraphTypeV1
    ) {
      this.rankingGraphType = rankingGraphType;
    }
  
    static fromDTO(dto: RankingDTO): Ranking {
      const rankingGraphType = RankingGraphTypeV1.fromDTO(getObject(dto, "rankingGraphType", InvalidQuestionViewGraphTypeV1RankingRankingGraphTypeError));
      return new Ranking(
        rankingGraphType
      );
    }
  
    toDTO(): RankingDTO {
      const dto: RankingDTO = {
        case: "RANKING",
          rankingGraphType: RankingGraphTypeV1.toDTO(this.rankingGraphType)
      };
      return dto;
    }
    }
  
  Ranking.prototype.toString = function toString(): string {
    return `QuestionViewGraphTypeV1.RANKING(rankingGraphType='${this.rankingGraphType}')`;
  };
  
  export interface OpenEndedDTO {
    case: string;
    openEndedGraphType: OpenEndedGraphTypeV1.OpenEndedGraphTypeV1DTO;
  }
  
  export class OpenEnded {
    readonly isQuestionViewGraphTypeV1OpenEnded: boolean = true;
  
    readonly openEndedGraphType: OpenEndedGraphTypeV1.OpenEndedGraphTypeV1;
  
  
    constructor(
    openEndedGraphType: OpenEndedGraphTypeV1.OpenEndedGraphTypeV1
    ) {
      this.openEndedGraphType = openEndedGraphType;
    }
  
    static fromDTO(dto: OpenEndedDTO): OpenEnded {
      const openEndedGraphType = OpenEndedGraphTypeV1.fromDTO(getObject(dto, "openEndedGraphType", InvalidQuestionViewGraphTypeV1OpenEndedOpenEndedGraphTypeError));
      return new OpenEnded(
        openEndedGraphType
      );
    }
  
    toDTO(): OpenEndedDTO {
      const dto: OpenEndedDTO = {
        case: "OPEN_ENDED",
          openEndedGraphType: OpenEndedGraphTypeV1.toDTO(this.openEndedGraphType)
      };
      return dto;
    }
    }
  
  OpenEnded.prototype.toString = function toString(): string {
    return `QuestionViewGraphTypeV1.OPEN_ENDED(openEndedGraphType='${this.openEndedGraphType}')`;
  };
  
  export interface GroupDTO {
    case: string;
    groupChildGraphDetails: GroupChildGraphDetailsV1DTO[];
  }
  
  export class Group {
    readonly isQuestionViewGraphTypeV1Group: boolean = true;
  
    readonly groupChildGraphDetails: GroupChildGraphDetailsV1[];
  
  
    constructor(
    groupChildGraphDetails: GroupChildGraphDetailsV1[]
    ) {
      this.groupChildGraphDetails = groupChildGraphDetails;
    }
  
    static fromDTO(dto: GroupDTO): Group {
      const groupChildGraphDetails = getList<GroupChildGraphDetailsV1DTO, GroupChildGraphDetailsV1>(
        dto,
        "groupChildGraphDetails",
        GroupChildGraphDetailsV1.fromDTO,
        InvalidQuestionViewGraphTypeV1GroupGroupChildGraphDetailsError
      );
      return new Group(
        groupChildGraphDetails
      );
    }
  
    toDTO(): GroupDTO {
      const dto: GroupDTO = {
        case: "GROUP",
          groupChildGraphDetails: this.groupChildGraphDetails.map((e: GroupChildGraphDetailsV1) => { return e.toDTO() })
      };
      return dto;
    }
    }
  
  Group.prototype.toString = function toString(): string {
    return `QuestionViewGraphTypeV1.GROUP(groupChildGraphDetails='${this.groupChildGraphDetails}')`;
  };
  
  export interface GridDTO {
    case: string;
    gridElementGraphTypes: GridElementGraphTypeV1DTO[];
  }
  
  export class Grid {
    readonly isQuestionViewGraphTypeV1Grid: boolean = true;
  
    readonly gridElementGraphTypes: GridElementGraphTypeV1[];
  
  
    constructor(
    gridElementGraphTypes: GridElementGraphTypeV1[]
    ) {
      this.gridElementGraphTypes = gridElementGraphTypes;
    }
  
    static fromDTO(dto: GridDTO): Grid {
      const gridElementGraphTypes = getList<GridElementGraphTypeV1DTO, GridElementGraphTypeV1>(
        dto,
        "gridElementGraphTypes",
        GridElementGraphTypeV1.fromDTO,
        InvalidQuestionViewGraphTypeV1GridGridElementGraphTypesError
      );
      return new Grid(
        gridElementGraphTypes
      );
    }
  
    toDTO(): GridDTO {
      const dto: GridDTO = {
        case: "GRID",
          gridElementGraphTypes: this.gridElementGraphTypes.map((e: GridElementGraphTypeV1) => { return e.toDTO() })
      };
      return dto;
    }
    }
  
  Grid.prototype.toString = function toString(): string {
    return `QuestionViewGraphTypeV1.GRID(gridElementGraphTypes='${this.gridElementGraphTypes}')`;
  };
  

  export type QuestionViewGraphTypeV1 = SingleSelect | SingleSelectWithProportion | SingleSelectNps | MultiSelect | Ranking | OpenEnded | Group | Grid;

  export type QuestionViewGraphTypeV1DTO = SingleSelectDTO | SingleSelectWithProportionDTO | SingleSelectNpsDTO | MultiSelectDTO | RankingDTO | OpenEndedDTO | GroupDTO | GridDTO;

  export const fromDTO = (dto: QuestionViewGraphTypeV1DTO): QuestionViewGraphTypeV1 => {
    switch (dto.case) {
      case "SINGLE_SELECT":
          return SingleSelect.fromDTO(dto as SingleSelectDTO);
      case "SINGLE_SELECT_WITH_PROPORTION":
          return SingleSelectWithProportion.fromDTO(dto as SingleSelectWithProportionDTO);
      case "SINGLE_SELECT_NPS":
          return SingleSelectNps.fromDTO(dto as SingleSelectNpsDTO);
      case "MULTI_SELECT":
          return MultiSelect.fromDTO(dto as MultiSelectDTO);
      case "RANKING":
          return Ranking.fromDTO(dto as RankingDTO);
      case "OPEN_ENDED":
          return OpenEnded.fromDTO(dto as OpenEndedDTO);
      case "GROUP":
          return Group.fromDTO(dto as GroupDTO);
      case "GRID":
          return Grid.fromDTO(dto as GridDTO);
      default:
        throw new InvalidQuestionViewGraphTypeV1Error(
            `Case ${dto.case} is not valid case of QuestionViewGraphTypeV1.`
        );
    }
  };
}

export class InvalidQuestionViewGraphTypeV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1Error";
  }
}
export class InvalidQuestionViewGraphTypeV1SingleSelectError extends InvalidQuestionViewGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1SingleSelectError";
  }
}

export class InvalidQuestionViewGraphTypeV1SingleSelectSingleSelectGraphTypeError extends InvalidQuestionViewGraphTypeV1SingleSelectError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1SingleSelectSingleSelectGraphTypeError";
  }
}

export class InvalidQuestionViewGraphTypeV1SingleSelectWithProportionError extends InvalidQuestionViewGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1SingleSelectWithProportionError";
  }
}

export class InvalidQuestionViewGraphTypeV1SingleSelectWithProportionSingleSelectWithProportionGraphTypeError extends InvalidQuestionViewGraphTypeV1SingleSelectWithProportionError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1SingleSelectWithProportionSingleSelectWithProportionGraphTypeError";
  }
}

export class InvalidQuestionViewGraphTypeV1SingleSelectNpsError extends InvalidQuestionViewGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1SingleSelectNpsError";
  }
}

export class InvalidQuestionViewGraphTypeV1SingleSelectNpsSingleSelectNpsGraphTypeError extends InvalidQuestionViewGraphTypeV1SingleSelectNpsError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1SingleSelectNpsSingleSelectNpsGraphTypeError";
  }
}

export class InvalidQuestionViewGraphTypeV1MultiSelectError extends InvalidQuestionViewGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1MultiSelectError";
  }
}

export class InvalidQuestionViewGraphTypeV1MultiSelectMultiSelectGraphTypeError extends InvalidQuestionViewGraphTypeV1MultiSelectError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1MultiSelectMultiSelectGraphTypeError";
  }
}

export class InvalidQuestionViewGraphTypeV1RankingError extends InvalidQuestionViewGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1RankingError";
  }
}

export class InvalidQuestionViewGraphTypeV1RankingRankingGraphTypeError extends InvalidQuestionViewGraphTypeV1RankingError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1RankingRankingGraphTypeError";
  }
}

export class InvalidQuestionViewGraphTypeV1OpenEndedError extends InvalidQuestionViewGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1OpenEndedError";
  }
}

export class InvalidQuestionViewGraphTypeV1OpenEndedOpenEndedGraphTypeError extends InvalidQuestionViewGraphTypeV1OpenEndedError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1OpenEndedOpenEndedGraphTypeError";
  }
}

export class InvalidQuestionViewGraphTypeV1GroupError extends InvalidQuestionViewGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1GroupError";
  }
}

export class InvalidQuestionViewGraphTypeV1GroupGroupChildGraphDetailsError extends InvalidQuestionViewGraphTypeV1GroupError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1GroupGroupChildGraphDetailsError";
  }
}

export class InvalidQuestionViewGraphTypeV1GridError extends InvalidQuestionViewGraphTypeV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1GridError";
  }
}

export class InvalidQuestionViewGraphTypeV1GridGridElementGraphTypesError extends InvalidQuestionViewGraphTypeV1GridError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidQuestionViewGraphTypeV1GridGridElementGraphTypesError";
  }
}
